module.exports = __webpack_public_path__ + "img/exception_403.f7518616.png";